import UserApi from "@/api/user/UserApi";

const state = {
  accessToken: sessionStorage.getItem("AccessToken") || null,
  isLoggedIn: false,
  userStatus: 'guest',
  username: null,
  email: null,
  upload: null,
};

const mutations = {
  setAccessToken(state, token) {
    state.accessToken = token;
  },
  SET_LOGIN_STATUS(state, isLoggedIn) {
    state.isLoggedIn = isLoggedIn;
  },
  setUserStatus(state, status) {
    state.userStatus = status;
  },
  setUsername(state, username) {
    state.username = username;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setUpload(state, upload) {
    state.upload = upload;
  }

};

const actions = {
  async login({ commit, dispatch }, { email, password }) {
    return UserApi.loginApi(email, password).then(data => {
      sessionStorage.setItem("AccessToken", data.access_token);
      commit('setAccessToken', data.access_token);
      commit('SET_LOGIN_STATUS', true);
      dispatch('adminCheck');
      dispatch('naviList/list', null, { root: true });
      return data;
    }).catch(error => {
      console.error('Login error:', error);
      throw error;
    });
  },

  async logout({ commit }) {
    return UserApi.logoutApi().then(() => {
      sessionStorage.removeItem("AccessToken");
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUsername', null);
      commit('setEmail', null);
      commit('setUpload', null);
    }).catch(error => {
      console.error('Logout error:', error);
      throw error;
    });
  },
  checkAuth({ commit, dispatch, state }) {
    const token = sessionStorage.getItem("AccessToken");
    if (token) {
      if (!state.isLoggedIn) {
        commit('setAccessToken', token);
        commit('SET_LOGIN_STATUS', true);
        dispatch('naviList/list', null, { root: true });
      }
    } else if (state.isLoggedIn) {
      commit('setAccessToken', null);
      commit('SET_LOGIN_STATUS', false);
      commit('setUserStatus', 'guest');
    }
  },
  async adminCheck({ commit }) {
    try {
      const response = await UserApi.admincheck();
      //console.log('re', response);
      commit('setUserStatus', response.admin === "admin" ? 'admin' : 'guest');
      commit('setUsername', response.username);
      commit('setEmail', response.email);
      commit('setUpload', response.upload);
    } catch (error) {
      //console.error('Admin check error', error);
      commit('setUserStatus', 'guest');
      commit('setUsername', null);
      commit('setEmail', null);
      commit('setUpload', null);
    }
  },
  async changeUploadOption({ commit }, uploadOption) {
    const data = {
      upload_option: uploadOption
    };
    const response = await UserApi.uploadoptionChange(data);
    if (response.status === 1) {
      commit('setUpload', uploadOption);
      return { success: true, message: response.message };
    } else {
      return { success: false, error: response.message || 'Error' };
    }
  }
};

const getters = {
  isLoggedIn: state => state.isLoggedIn,
  userStatus: state => state.userStatus,
  username: state => state.username,
  email: state => state.email,
  upload: state => state.upload
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
